import { NotificationManager } from 'react-notifications';
import { SERVER_API } from "../../../config.json"
import Cookies from 'universal-cookie';
const cookies = new Cookies();

let DataTest = [
    {
        ID: 1,
        Task: "Task1",
    },
    {
        ID: 2,
        Task: "Task2",
    },
    {
        ID: 3,
        Task: "Task3",
    }
];
// eslint-disable-next-line 
function* GetDataLoginFromApi() {
    return DataTest;
}
function* SetDataLoginFromApi(DataLogin) {
    if (!DataLogin.StatusDelete) {
        if (!DataLogin.ID) {
            let ID = 1;
            // eslint-disable-next-line 
            DataTest.map((item) => {
                if (item.ID >= ID) {
                    ID = item.ID;
                }
            })
            DataTest.push({ ID: ID + 1, Task: DataLogin.Task })
            NotificationManager.success("Thêm thành công");
            return true;
        }
        else {
            // eslint-disable-next-line 
            DataTest.map((item) => {
                if (item.ID === DataLogin.ID) {
                    item.Task = DataLogin.Task;
                }
            });
            NotificationManager.success("Sửa thành công");
            return true;
        }
    }
    else {
        var index1;
        // eslint-disable-next-line 
        DataTest.map((item, index) => {
            if (item.ID === DataLogin.ID) {
                index1 = index;
            }
        });

        if (index1 !== undefined) {
            NotificationManager.success("Xóa thành công");
            DataTest.splice(index1, 1);
            return yield true;
        } else {
            NotificationManager.error("Task không tồn tại");
            return false;
        }
    }
    // return yield false;
}

function* LoginFromApi(token) {
    //console.log("Token11", token);
    const response = yield fetch(SERVER_API + "api/User/Login", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'codeIAM': token
        },
    }); 
    //console.log("Respone", response);
    const Data = yield response.json();
    if (Data.status === "OK") {
        cookies.remove('errorDescription');
        cookies.remove('errorDescription', { path: '/' });
        cookies.set('usercode', Data.data);
        window.localStorage.setItem("User", Data.data.userCode ? Data.data.userCode : 0);
        window.localStorage.setItem("Name", Data.data.lastName ? Data.data.fullName : "");
        window.localStorage.setItem("Email", Data.data.email ? Data.data.email : "");
        //window.location.reload();
        NotificationManager.success('Đăng nhập thành công');
        return yield Data;
    }
    else {
        cookies.set('errorDescription', Data.errorDescription);
        localStorage.removeItem('keycloakcode');
        if (Data.errorDescription === "Invalid user credentials") {
            NotificationManager.error('Thông tin tài khoản hoặc mật khẩu không chính xác!', '', 3000);
        }
        else if (Data.errorDescription === "Account is not fully set up") {
            NotificationManager.error('Tài khoản cần phải cập nhật mật khẩu mới vui lòng truy cập link đổi pass để cập nhật!', '', 10000);
            setTimeout(() => {
                window.open('https://iam.fpt.vn/auth/realms/fpt/protocol/openid-connect/auth?client_id=account-console&redirect_uri=https%3A%2F%2Fiam.fpt.vn%2Fauth%2Frealms%2Ffpt%2Faccount%2F%23%2F&state=f3d6e0e5-f4cb-4a63-9193-e2956f089400&response_mode=fragment&response_type=code&scope=openid&nonce=b75260c4-49b5-495c-8319-bb175a03c4a4&code_challenge=IHFn6TdsVSlwAWJP443PdpBQPOK8pj-Zzjn_2yda_84&code_challenge_method=S256', "_blank");
            }, 4000);
        }
        else if (Data.errorDescription === "Account disabled") {

            NotificationManager.error('Tài khoản đã bị block, Vui lòng liên hệ admin IAM !', '', 4000);
        }
        else {
            NotificationManager.error('Thông tin tài khoản không chính xác!', '', 3000);
        }
        return yield Data;
    }
}

//CreateFuntionHygen
export const Api = {
    GetDataLoginFromApi,
    SetDataLoginFromApi,
    LoginFromApi,
    //ExportFuntionHygen
}